import * as React from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
// import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import GrainIcon from "@mui/icons-material/Grain";
import { Link, useLocation } from "react-router-dom";
import "../BreadCrumb/BreadCrumb.scss";
function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

export default function BreadCrumb(props) {
  const { data, lastData } = props;
  //   const navigate = useNavigate();
  return (
    <div role="presentation">
      <div className="breadCrumbDiv">
        <Breadcrumbs aria-label="breadcrumb">
          {data.map((item, index) => (
            <Link
              className="breadCrumbsStyle"
              to={item.href}
              style={{ color: "black", ":hover": { color: "#f26639" } }}
              key={index}
            >
              <img
                src={item.source}
                alt={item.id}
                width={"15px"}
                height={"15px"}
                style={{ marginBottom: "3px", marginRight: "5px" }}
              />
              {item.title}
            </Link>
            //   <Link
            //   </Link>
          ))}

          {lastData != "" && <Typography
            sx={{ display: "flex", alignItems: "center" }}
            color="text.primary"
          >
            <GrainIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            {lastData}
          </Typography>}
        </Breadcrumbs>
      </div>
    </div>
  );
}
